import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import NavbarStandard from 'components/pages/landing/NavbarStandard';
import FooterStandard from 'components/pages/landing/FooterStandard';

const sections = [
  {
    title: '1. Responsable del tratamiento',
    paragraphs: [
      'Gestodo es operado por Bytewave SA, CUIT 30-71828181-0.',
      'Para cualquier consulta: Email: info@gestodo.net - Sitio web: https://gestodo.net'
    ]
  },
  {
    title: '2. Qué es Gestodo',
    paragraphs: [
      'Gestodo es una plataforma SaaS que permite a vendedores, empresas y consultores gestionar conversaciones, ventas, postventa y automatizaciones, integrando canales como marketplaces, mensajería y redes sociales.'
    ]
  },
  {
    title: '3. Datos que recopilamos',
    paragraphs: ['Podemos recopilar los siguientes datos:'],
    lists: [
      {
        heading: '3.1 Datos del usuario (cliente de Gestodo)',
        items: [
          'Nombre y apellido',
          'Email',
          'Teléfono',
          'Empresa / CUIT / DNI',
          'País',
          'Información comercial (ventas estimadas, categorías, canales)'
        ]
      },
      {
        heading: '3.2 Datos operativos',
        items: [
          'Conversaciones con clientes',
          'Mensajes enviados y recibidos',
          'Historial de respuestas',
          'Interacciones con publicaciones',
          'Métricas de rendimiento'
        ]
      },
      {
        heading: '3.3 Datos técnicos',
        items: ['Dirección IP', 'Dispositivo y navegador', 'Cookies y tracking']
      }
    ]
  },
  {
    title: '4. Uso de la información',
    paragraphs: ['Utilizamos la información para:'],
    lists: [
      {
        items: [
          'Operar y mejorar la plataforma',
          'Automatizar respuestas y procesos',
          'Analizar comportamiento comercial',
          'Brindar soporte',
          'Mejorar rendimiento de ventas',
          'Desarrollar nuevas funcionalidades'
        ]
      }
    ]
  },
  {
    title: '5. Uso de Inteligencia Artificial',
    paragraphs: [
      'Gestodo utiliza agentes de inteligencia artificial para optimizar la gestión comercial.',
      'IMPORTANTE: Los agentes de IA analizan conversaciones y datos operativos, aprenden del comportamiento del usuario, detectan patrones de venta, respuesta y atención, y mejoran automáticamente sugerencias y automatizaciones.',
      'Esto significa que la plataforma puede adaptar respuestas, flujos y decisiones en función de cómo el usuario trabaja.'
    ]
  },
  {
    title: '6. Aprendizaje automático y personalización',
    paragraphs: [
      'Al utilizar Gestodo, el usuario acepta que sus datos pueden ser utilizados para entrenar modelos internos, que los agentes de IA pueden aprender su estilo de comunicación y que el sistema puede optimizar procesos de forma autónoma.',
      'Este aprendizaje se realiza de forma automatizada, con fines de mejora del servicio y sin intervención manual directa sobre datos sensibles.'
    ]
  },
  {
    title: '7. Uso de algoritmos',
    paragraphs: ['Gestodo utiliza algoritmos para:'],
    lists: [
      {
        items: [
          'Clasificar conversaciones',
          'Priorizar clientes',
          'Detectar oportunidades de venta',
          'Automatizar respuestas',
          'Optimizar tiempos de respuesta'
        ]
      },
      {
        heading: 'Estos algoritmos pueden influir en:',
        items: [
          'Qué mensajes se envían',
          'Cómo se responde',
          'Qué acciones se priorizan'
        ]
      }
    ]
  },
  {
    title: '8. Compartición de datos',
    paragraphs: [
      'No vendemos datos personales.',
      'Podemos compartir información con:'
    ],
    lists: [
      {
        items: [
          'Proveedores tecnológicos (hosting, infraestructura)',
          'Integraciones autorizadas (ej: APIs, mensajería, marketplaces)',
          'Autoridades legales si es requerido'
        ]
      }
    ]
  },
  {
    title: '9. Seguridad de la información',
    paragraphs: ['Implementamos medidas de seguridad como:'],
    lists: [
      {
        items: [
          'Encriptación de datos',
          'Accesos restringidos',
          'Monitoreo de actividad',
          'Protección contra accesos no autorizados'
        ]
      }
    ]
  },
  {
    title: '10. Derechos del usuario',
    paragraphs: ['El usuario puede:'],
    lists: [
      {
        items: [
          'Acceder a sus datos',
          'Solicitar corrección',
          'Solicitar eliminación',
          'Retirar consentimiento'
        ]
      }
    ],
    footer: 'Solicitudes a: info@gestodo.net'
  },
  {
    title: '11. Uso de cookies',
    paragraphs: ['Utilizamos cookies para:'],
    lists: [
      {
        items: ['Mejorar experiencia', 'Analizar tráfico', 'Personalizar contenido']
      }
    ],
    footer: 'El usuario puede desactivarlas desde su navegador.'
  },
  {
    title: '12. Responsabilidad sobre automatizaciones',
    paragraphs: [
      'Gestodo permite automatizar acciones comerciales.',
      'El usuario entiende que:'
    ],
    lists: [
      {
        items: [
          'Es responsable del uso de las automatizaciones',
          'Debe supervisar las respuestas generadas por IA',
          'Las decisiones comerciales siguen siendo del usuario'
        ]
      }
    ]
  },
  {
    title: '13. Cambios en la política',
    paragraphs: [
      'Podemos modificar esta política en cualquier momento.',
      'Las actualizaciones se publicarán en: https://gestodo.net'
    ]
  },
  {
    title: '14. Aceptación',
    paragraphs: ['El uso de Gestodo implica la aceptación de esta política.']
  }
];

const PrivacyPolicyPage = () => {
  return (
    <>
      <NavbarStandard solid />
      <main>
        <section className="bg-300 py-6 mt-6">
          <Container>
            <h1 className="mb-3">POLÍTICA DE PRIVACIDAD - GESTODO</h1>
            <p className="text-700 mb-1">Bytewave SA</p>
            <p className="text-700 mb-1">CUIT: 30-71828181-0</p>
            <p className="text-700 mb-1">Sitio web: https://gestodo.net</p>
            <p className="text-700 mb-0">Email: info@gestodo.net</p>
          </Container>
        </section>
        <section className="py-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={9}>
                <Card className="border shadow-sm">
                  <Card.Body className="p-4 p-lg-5">
                    {sections.map(section => (
                      <div key={section.title} className="mb-4">
                        <h4 className="mt-3 mb-3">{section.title}</h4>
                        {(section.paragraphs || []).map(paragraph => (
                          <p key={paragraph} className="mb-3 text-700">
                            {paragraph}
                          </p>
                        ))}
                        {(section.lists || []).map(list => (
                          <div key={list.heading || list.items.join('|')} className="mb-3">
                            {list.heading && (
                              <p className="mb-2 text-700 fw-semi-bold">{list.heading}</p>
                            )}
                            <ul className="mb-0 text-700">
                              {list.items.map(item => (
                                <li key={item} className="mb-1">
                                  {item}
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                        {section.footer && (
                          <p className="mb-0 text-700">{section.footer}</p>
                        )}
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <FooterStandard />
    </>
  );
};

export default PrivacyPolicyPage;
